<template>
  <div class="flex justify-center items-center h-screen">
    <div class="flex flex-col items-center">
      <template v-if="aiRun?.status === 'finished'">
        <h2 class="text-2xl text-gray-500 mb-8">Hooray! Your template is ready!</h2>
        <LSButton
          type="secondary"
          variant="outline"
          size="small"
          @click="router.push({ name: 'edit-template', params: { templateID: aiRun.template_id } })"
          >View Template</LSButton
        >
      </template>
      <template v-else-if="aiRun?.status === 'error'">
        <h2 class="text-2xl text-gray-500 mb-8">Oops! Something went wrong.</h2>
        <p class="text-sm text-gray-500 mb-8">{{ aiRun?.error }}</p>
        <LSButton type="secondary" variant="outline" size="small" @click="router.push({ name: 'templateFromExample' })">
          Try Again
        </LSButton>
      </template>
      <template v-else>
        <CubeTransparentIcon class="animate-ping duration-75 w-8 h-8" />
        <p class="text-sm text-gray-500 mt-8 font-bold">Generating your template...</p>
        <p class="text-sm text-gray-500 mt-2">{{ aiRun?.status }}</p>
        <p class="text-sm text-gray-500 mt-2">
          Don't worry if this takes a while. You can safely close this page. We'll send you an email when it's ready. Or you just wait here
          until it's ready.
        </p>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getAiRun } from '@/admin/services/template-service'
import { useQuery } from '@tanstack/vue-query'
import { toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { CubeTransparentIcon } from '@heroicons/vue/24/outline'
import LSButton from '@/components/LSButton.vue'

const props = defineProps<{
  id: string
}>()

const { id } = toRefs(props)
const router = useRouter()

const { data: aiRun } = useQuery({
  queryKey: ['aiRun', id.value],
  queryFn: () => getAiRun(id.value),
  refetchInterval: query => {
    const didFinish = query.state.data?.status === 'finished'
    const didError = query.state.data?.error
    if (didFinish || didError) {
      console.log(`Stopping refetch interval. didFinish: ${didFinish}, didError: ${didError}`)
      return false
    }
    return 2000
  },
  refetchIntervalInBackground: true,
  refetchOnMount: true,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
})
</script>
